import { Box, CircularProgress, Typography } from "@material-ui/core";

export default function ScoringToggleButton({ isOn, disabled, handleClick, loading, ...props }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      style={{
        borderRadius: "6px",
        backgroundColor: isOn ? "#1C8CF3" : "#7994C1",
        width: "43px",
        height: "32px",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={handleClick}
      {...props}
    >
      <Typography style={{ color: "#FFFFFF", fontSize: "14px", display: "flex", alignItems: "center" }}>
        {loading ? <CircularProgress color="inherit" size={18} /> : isOn ? "On" : "Off"}
      </Typography>
    </Box>
  );
}
